import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, Badge } from 'reactstrap';

import _ from 'lodash';
import Link from 'next/link';
import domainModel from 'domain-model';

import ArticleBadges from './ArticleBadges';
import ArticleImage from 'flaivy-react/components/article/ArticleImage';
import ArticleQuantityInput from 'flaivy-react/components/cart/CartArticleQuantityInput';

import ArticleHeart from './ArticleHeart';
import LoginToShowPrices from '../LoginToShowPrices';
import DiscountFlag from './DiscountFlag';

_.mixin(require('lodash-uuid'));

class ArticleCard extends PureComponent {
  static get propTypes() {
    return {
      article: PropTypes.object.isRequired,
    };
  }

  render() {
    const { article } = this.props;
    const viewModel = domainModel.article.getViewModel(article);
    return (
      <Col xs={12} id={article.id}>
        <Card
          className={`article-list-card p-1 my-1 ${
            article.cancelled ? 'inactive-article' : ''
          }`}
        >
          <Row className="align-items-center align-items-center">
            <Col className="d-none d-sm-block" sm="auto">
              <Link href={`/articles/${article.id}`} passHref>
                <ArticleImage
                  resX={100}
                  resY={100}
                  className="ms-1 rounded"
                  layout="fixed"
                  article={article}
                  alt="article"
                />
              </Link>
              <ArticleBadges article={article} />
              <DiscountFlag article={article} />
            </Col>
            <Col>
              <Row>
                <Col sm={6}>
                  <ArticleHeart article={article} size="lg" />
                  <Link href={`/articles/${article.id}`} passHref>
                    <h5>{article.shortName}</h5>
                    {article.brand && (
                      <>
                        <strong>{article.brand.name} </strong>
                        <br />
                      </>
                    )}
                    {article.supplier && (
                      <>
                        <strong>{article.supplier.name} </strong>
                      </>
                    )}
                  </Link>
                  <br />
                  {article.productCategory?.startsWith('Dryck|Vin') && (
                    <Badge
                      color="secondary"
                      className="text-center px-2 rounded-pill me-2"
                    >
                      {viewModel.brandName && viewModel.brandName + ' | '}
                      {article.vintage && 'År ' + article.vintage + ' | '}
                      {article.grapes && article.grapes + ' | '}
                      {viewModel.displayContainer &&
                        viewModel.displayContainer + ' | '}
                      {article.alcoholPercentage &&
                        article.alcoholPercentage + '% alk'}
                    </Badge>
                  )}
                </Col>

                <Col sm={6} className="text-center">
                  <LoginToShowPrices>
                    <ArticleQuantityInput
                      className="mt-1"
                      article={article}
                      {...{
                        article,
                      }}
                    />
                  </LoginToShowPrices>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Col>
    );
  }
}
export default ArticleCard;
